/**
 * Static media from `public/site-media/`.
 * Respects Vite `base` for subpath deploys.
 */
function asset(file: string): string {
  const base = import.meta.env.BASE_URL;
  const root = base.endsWith("/") ? base : `${base}/`;
  return `${root}site-media/${file}`;
}

export const SITE_MEDIA = {
  avaFace512: asset("ava-face-512.png"),
  avaIllustration: asset("ava-illustration.png"),
  brandIcon512: asset("brand-icon-512.png"),
  avaHeroVideo: asset("ava-hero-video.mp4"),
  avaVoiceDemo: asset("ava-voice-demo.mp4"),
  problem1: asset("problem-1.jpg"),
  problem2: asset("problem-2.jpg"),
  problem3: asset("problem-3.jpg"),
  problem4: asset("problem-4.jpg"),
  usecase1: asset("usecase-1.jpg"),
  usecase2: asset("usecase-2.jpg"),
  usecase3: asset("usecase-3.jpg"),
  usecase4: asset("usecase-4.jpg"),
  usecase5: asset("usecase-5.jpg"),
  emotional1: asset("emotional-1.jpg"),
  emotional2: asset("emotional-2.jpg"),
  emotional3: asset("emotional-3.jpg"),
  testimonial01: asset("testimonial-01.jpg"),
  testimonial02: asset("testimonial-02.jpg"),
  testimonial03: asset("testimonial-03.jpg"),
  testimonial04: asset("testimonial-04.jpg"),
  testimonial05: asset("testimonial-05.jpg"),
  testimonial06: asset("testimonial-06.jpg"),
  testimonial07: asset("testimonial-07.jpg"),
  testimonial08: asset("testimonial-08.jpg"),
  testimonial09: asset("testimonial-09.jpg"),
} as const;
